// extracted by mini-css-extract-plugin
export default {"AcceptedInvitesSuccess__table":"AcceptedInvitesSuccess_AcceptedInvitesSuccess__table__q9nb8"};